module.exports = __webpack_public_path__ + "static/media/invoice-inactive.7ed7ef98.svg";